import { gql } from '@apollo/client';

import APPOINTMENT_ASSIGNMENTS from '../appointmentAssignments/appointmentAssignments';
import baseFields from '../base';

const APPOINTMENTS_FRAGMENT = gql`
  ${APPOINTMENT_ASSIGNMENTS}
  fragment AppointmentsFragment on Appointment {
    ${baseFields}
    status
    documentStatus
    type
    signatoryIds
    date
    address
    duration
    description
    clientInPersonFee
    clientRONFee
    notaryGetInPerson
    notaryGetRON
    notary {
      firstName
      lastName
      id
    }
    assignments {
     ...AppointmentAssignments
    }
    files {
      details
      name
      path
      pipeFrom
      id
      status
      size
    }
    scannedFiles {
      createdAt
      id
      name
      size
      type
    }
    labelFiles {
      createdAt
      id
      name
      size
      type
    }
    autoGenShippingLabel
    transaction {
      requiredScanDoc
      id
    }
    shippingOptions
  }
`;
export default APPOINTMENTS_FRAGMENT;
